import { convertLabelIntoName } from "Utils/utils";
import { fieldTypeLabel } from "./formBuilderConstants";

const uniqueSuffix = () => Math.random().toString(36).slice(2, 6);

const DEFAULT_FIELD_LABELS = {
  text: "Short answer",
  textarea: "Detailed response",
  number: "Amount",
  date: "Date",
  email: "Email address",
  phone: "Phone number",
  checkbox: "I agree to the terms",
  radio: "Choose one option",
  select: "Select an option",
  address: "Home address",
  file: "Upload document",
  signature: "Signature",
  table: "Table entries",
  content: "Information",
};

export const createFieldFromPalette = (type) => {
  const label = DEFAULT_FIELD_LABELS[type] ?? fieldTypeLabel(type);
  const base = {
    lable: label,
    name: `${convertLabelIntoName(label)}_${uniqueSuffix()}`,
    type,
    required: false,
  };

  switch (type) {
    case "radio":
    case "select":
      return {
        ...base,
        numberOfOptions: 2,
        options: [
          { lable: "Option 1", type: "" },
          { lable: "Option 2", type: "" },
        ],
      };
    case "table":
      return {
        ...base,
        numberOfColumns: 2,
        columns: [
          { lable: "Column 1", name: "column_1", type: "text" },
          { lable: "Column 2", name: "column_2", type: "text" },
        ],
        rows: [
          [
            { lable: "Column 1", name: "column_1", type: "text", value: "" },
            { lable: "Column 2", name: "column_2", type: "text", value: "" },
          ],
        ],
      };
    case "content":
      return {
        ...base,
        name: "content",
        content: "<p>Add instructions or information for participants here.</p>",
      };
    case "address":
      return {
        ...base,
        address: {
          street: "",
          subrub: "",
          postcode: "",
          state: "New south Wales",
        },
      };
    case "sub_section":
      return {
        type: "sub_section",
        section_title: "New sub-section",
        lable: "",
        sub_fields: [],
        isAddOther: false,
      };
    default:
      return base;
  }
};

export const createEmptySection = (title = "New section") => ({
  section_title: title,
  input_fields: [],
});
